"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findPos = findPos;
exports.getIdDataset = getIdDataset;
exports.getInputValueIfExists = getInputValueIfExists;
function getInputValueIfExists(name) {
  var input = document.getElementsByName(name);
  if (input && input[0]) {
    return input[0].value;
  }
  return null;
}
function getIdDataset(name, dataSetName) {
  var elem = document.getElementById(name);
  if (elem && elem.dataset) {
    return elem.dataset[dataSetName];
  }
  return null;
}
function findPos(obj) {
  var curtop = 0;
  var myObj = obj;
  if (obj.offsetParent) {
    do {
      curtop += myObj.offsetTop;
      myObj = myObj.offsetParent;
    } while (myObj.offsetParent);
  }
  return [curtop - window.innerHeight / 2];
}